import apiService from './api';

// The playback-only token for <video>/<audio> URLs (server/utils/mediaToken.js). A media element cannot send
// an Authorization header, so its URL carries this token instead of the login token. It is kept in memory
// only, fetched after sign-in and renewed before it expires.
// The player builds its URL once, with the token it holds at that moment, so a token must never be close to
// expiry while a recording could start playing. Renewing with 4 of the 6 hours left means any playback
// starts with at least 4 hours of token - enough for a 3-hour recording.
const RENEW_BEFORE_MS = 4 * 60 * 60 * 1000;

let current = null;
let inflight = null;
let renewTimer = null;

export const getMediaToken = () => (current && current.expiresAt > Date.now() ? current.token : null);

export const clearMediaToken = () => {
  current = null;
  inflight = null;
  clearTimeout(renewTimer);
  renewTimer = null;
};

export const refreshMediaToken = async () => {
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const response = await apiService.request('/video/media-token');
      if (response?.token) {
        current = { token: response.token, expiresAt: response.expiresAt };
        clearTimeout(renewTimer);
        const delay = Math.max(60 * 1000, response.expiresAt - Date.now() - RENEW_BEFORE_MS);
        renewTimer = setTimeout(() => { refreshMediaToken(); }, delay);
      }
    } catch (error) {
      // Playback falls back to asking again the next time a player needs the token.
    } finally {
      inflight = null;
    }
    return getMediaToken();
  })();
  return inflight;
};
